import { useState } from 'react'
import { useArrangementStore } from '../../state/arrangementStore'
import { exportArrangementAsWav } from '../../audio/export'

interface ExportButtonProps {
  arrangementCount: number
}

export function ExportButton({ arrangementCount }: ExportButtonProps) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const disabled = busy || arrangementCount === 0

  const handleClick = async () => {
    if (disabled) return
    setError(null)
    setBusy(true)
    try {
      const { order, segments } = useArrangementStore.getState()
      await exportArrangementAsWav(order.map((id) => segments[id]))
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Export failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="advanced-save-export-wrap">
      <button
        type="button"
        className={`advanced-save-export ${busy ? 'is-busy' : ''}`}
        onClick={handleClick}
        disabled={disabled}
        aria-label="Download arrangement as WAV"
      >
        {busy ? 'RENDERING…' : '⬇ EXPORT ARRANGEMENT'}
      </button>
      {arrangementCount === 0 && (
        <p className="advanced-save-hint">Save at least one segment first.</p>
      )}
      {error && <p className="advanced-save-error">{error}</p>}
    </div>
  )
}
